<template>
  <div class="jlxk-view-container">
    <div :class="['list-container', { 'list-container-expand': expandFlag }]">
      <el-tabs
        v-model="currentList"
        @tab-click="handleChangeTab"
      >
        <el-tab-pane
          v-for="item in contentList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        >
          <keep-alive>
            <component
              v-if="currentList === item.name"
              :is="item.name"
              :ref="item.name"
              :is-show-data-type="true"
              :is-show-status="false"
              time-label="时间"
              :ajax-params="ajaxParams"
              :is-record-condition="isNoPassList"
              :handle-oper="handleOper"
              @changeSelected="changeSelected"
              @updateExpand="updateExpand"
            >
              <el-button
                v-for="(item, index) in operateList"
                :key="index"
                v-show="handleShow(item)"
                @click="handleCommand(item.code)"
                :class="{ active: item.code === handleOper }"
              >
                {{ item.name }}
              </el-button>
              <el-button
                v-show="handleShowDetection('')"
                @click="handleCommand('detection')"
              >
                检测
              </el-button>
            </component>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-tabs
      v-model="currentTab"
      class="tag-tab-conditon"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <components
            v-if="currentTab === item.name"
            :is="item.name"
            :ref="item.name"
            :is-show-operate="isNoPassList"
            :is-can-add="isCanAdd"
            :is-show-pass-btn="isNoPassList"
            :current-item="currentItem"
            :is-show-review-oper="
              isNoPassList || (!isNoPassList && isFirstManager)
            "
            @operate="operate"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <sureDialog
      ref="sureDialog"
      class="sureDialog"
      :is-show-footer="isShowOper"
      width="450px"
      :is-tran-cancel="true"
      @dialogSure="getSpcialCheck"
      @handleCancel="handleCancel"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ tips }}
      </div>
    </sureDialog>
    <checkDialog
      ref="checkDialog"
      :type="type"
      :checked-list="checkedListData"
      @handleVideoCheck="getMamAICheck"
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import notPass from '@components/jgsd/commonList'
// eslint-disable-next-line import/no-duplicates
import passed from '@components/jgsd/commonList'
import detail from '@components/jgsd/detail'
import tag from '@views/jgsd/dataView/components/tag'
import reviewManage from './components/reviewManage'
import sureDialog from '@components/dialog/cyDialogCommon'
import checkDialog from './components/checkDialog'
import jlxkAPIS from '@apis/jlxk'
import { isCanAcess } from '@common/index.js'
export default {
  name: 'Review',
  components: {
    notPass,
    passed,
    detail,
    tag,
    reviewManage,
    sureDialog,
    checkDialog
  },
  props: {},
  data() {
    return {
      expandFlag: true,
      currentList: 'notPass',
      contentList: [
        {
          name: 'notPass',
          label: '待审读列表'
        },
        {
          name: 'passed',
          label: '已审读列表'
        }
      ],
      currentTab: 'detail',
      tabList: [
        {
          name: 'detail',
          label: '详情'
        },
        {
          name: 'reviewManage',
          label: '审读管理'
        },
        {
          name: 'tag',
          label: '标签'
        }
      ],
      handleOper: '',
      isShowOper: true,
      reviewManage: {},
      type: 'video',
      checkedListData: [],
      currentItem: {},
      operateList: [
        {
          name: '通过',
          code: 'pass'
        },
        {
          name: '不通过',
          code: 'reback'
        }
      ]
    }
  },
  computed: {
    isNoPassList() {
      return this.currentList === 'notPass'
    },
    ajaxParams() {
      let params = {
        showContent: 0,
        isCheck: 1,
        timeFlag: undefined
      }
      return Object.assign({}, params, {
        status: this.isNoPassList ? '4' : '5',
        isPassedList: !this.isNoPassList
      })
    },
    dataArr() {
      return this.listData.map(item => item.id)
    },
    isHandlePass() {
      return this.handleOper === 'pass'
    },
    tips() {
      return this.isShowOper
        ? this.isHandlePass
          ? '确定要做此操作：通过？'
          : '确定要做此操作：不通过？'
        : '请选择稿件'
    },
    isFirstManager() {
      return (
        login_cookie['departmentId'] === 0 && login_cookie['userType'] === 1
      )
    },
    isShowAIPic() {
      return auth_ai_pic_enabled
    },
    isCanAdd() {
      return (this.isNoPassList && this.currentItem && this.currentItem.system && String(this.currentItem.system) !== '1') || false
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
  },
  methods: {
    handleChangeTab() {
      this.$nextTick(() => {
        this.changeSelected(this.$refs[this.currentList][0].currentItem)
      })
    },
    // 审批：通过、不通过
    async getSpcialCheck() {
      let params = {
        ids: this.$refs[this.currentList][0].checkedLists.join(','),
        toStatus: this.isHandlePass ? '5' : '6',
        operate: this.isHandlePass ? '通过' : '不通过',
        comment: ''
      }
      let { status, message } = await jlxkAPIS.postSpcialCheck({
        data:
          JSON.stringify(this.reviewManage) !== '{}'
            ? this.reviewManage
            : params
      })
      if (status === 0) {
        this.reviewManage = {}
        this.handleOper = ''
        this.$refs.sureDialog.cyDialogCommon = false
        this.$refs[this.currentList][0].resetCheck()
        this.$refs[this.currentList][0].totalData = []
        this.$refs[this.currentList][0].getList()
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    // 图集、影视作品获取图片详情
    async getFindImgList(params) {
      let { status, data } = await jlxkAPIS.postFindImgList({ data: params })
      if (status === 0 && data && data.length !== 0) {
        this.checkedListData[0].attachments = [...data]
      }
      this.$refs.checkDialog.$refs.videoCheckDialog.cyDialogCommon = true
    },
    // 检测
    async getMamAICheck(params) {
      let isImg = params.type
      let _api = !isImg ? jlxkAPIS.postImageAiCheck : jlxkAPIS.postMamAICheck
      let { status, message } = await _api({
        data: params,
        headers: { 'Content-Type': 'application/json' }
      })
      if (status === 0) {
        this.$refs[this.currentList][0].resetCheck()
        let flag = !isImg ? '图片' : params.type === 'audio' ? '音频' : '视频'
        this.global_.handleMessageTips(
          `检测任务已创建，请稍候在${flag}详情中查看分析结果`,
          'success'
        )
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    operate(value) {
      this.isShowOper = true
      this.reviewManage = value
      this.$refs.sureDialog.cyDialogCommon = true
      this.handleOper = value.operate === '通过' ? 'pass' : 'reback'
    },
    handleCancel() {
      this.handleOper = ''
      this.reviewManage = {}
    },
    // 审批
    handleCommand(flag) {
      if (flag === 'detection') {
        this.checkedListData = []
        this.$refs[this.currentList][0].totalData.forEach(item => {
          if (
            this.$refs[this.currentList][0].checkedLists.indexOf(item.id) !== -1
          ) {
            this.checkedListData.push(item)
          }
        })
        this.type = this.$refs[this.currentList][0].type
        // 如果是图片且是图文或者影视作品需要获取content字段处理图片集
        let articletypeidArr = [1, 4]
        if (
          (this.type === 'img' &&
          articletypeidArr.indexOf(this.checkedListData[0].articletypeid) !== -1) || String(this.checkedListData[0].system) === '1'
        ) {
          this.getFindImgList({
            docId: this.checkedListData[0].id,
            articleTypeId: this.checkedListData[0].articletypeid
          })
          return false
        }
        this.$refs.checkDialog.$refs.videoCheckDialog.cyDialogCommon = true
        return false
      }
      this.isShowOper = this.$refs[this.currentList][0].checkedLists.length !== 0
      this.$refs.sureDialog.cyDialogCommon = true
      this.handleOper = flag
    },
    updateExpand(val) {
      this.expandFlag = val
    },
    changeSelected(val) {
      this.currentItem = val
    },
    // 通过、退回的展示
    handleShow(value) {
      if (value.code === 'pass') return this.isNoPassList
      return this.isNoPassList ? true : this.isFirstManager
    },
    // 检测展示判断
    handleShowDetection() {
      if (!this.$refs[this.currentList] || !this.$refs[this.currentList][0]) { return false }
      if (
        this.$refs[this.currentList][0].checkedLists.length === 0 ||
        !isCanAcess('/jgsd/review') ||
        this.isPassedList
      ) {
        return false
      }
      let result = []
      this.$refs[this.currentList][0].checkedLists.forEach(item => {
        let checkItem = this.$refs[this.currentList][0].totalData.find(
          sub => String(sub.id) === String(item)
        )
        if (checkItem) {
          result.push(checkItem.articletypeid)
        }
      })
      let imgList = [1, 2, 4]
      let video = result.filter(item => item === 5)
      let audio = result.filter(item => item === 6)
      let img = result.filter(item => imgList.indexOf(item) !== -1)
      this.type =
        video.length === result.length
          ? 'video'
          : audio.length === result.length
            ? 'audio'
            : 'img'
      let lenArr = [video.length, audio.length]
      if (
        lenArr.indexOf(result.length) !== -1 ||
        (img.length === result.length &&
          result.length === 1 &&
          this.isShowAIPic)
      ) { return true }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-view-container {
  display: flex;
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-radius: 5px 5px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
        }
        &::after {
          height: 1px;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
  }
  .list-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 0 12px 0 0;
    @extend .comBackground;
    /deep/ .el-tabs {
      &__header {
        display: none;
        margin: 0 15px 0 25px;
        .el-tabs__item {
          line-height: 48px;
          padding: 0 60px 0 0;
        }
      }
      &__content {
        overflow: inherit;
      }
    }
    /deep/ .jlxk-data-content {
      position: relative;
      width: 100%;
      margin: 0;
      box-shadow: none;
    }
    &-expand {
      /deep/ .el-tabs {
        &__header {
          display: block;
        }
      }
      /deep/ .jlxk-data-content {
        height: calc(100vh - 145px);
      }
    }
  }
  /deep/ .el-tabs.tag-tab-conditon {
    width: 440px;
    @extend .comBackground;
    .el-tabs__header {
      width: 100%;
      margin: 0;
      background: #ffffff;
      border-radius: 5px 5px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
        }
        &::after {
          height: 1px;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
    .el-tabs__content {
      overflow: initial;
      background-color: #fff;
      .data-view-detail-container {
        .detail-container {
          padding: 15px 20px 5px;
          height: calc(100vh - 192px);
          overflow-y: auto;
        }
      }
    }
  }
  /deep/ .sureDialog {
    .delete-icon-box {
      width: 60px;
      height: 60px;
      background-color: #f3c245;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
    }
    .delete-text {
      text-align: center;
    }
    .el-dialog__footer {
      margin: 0;
    }
  }
}
</style>
